import { render, staticRenderFns } from "./modal-viewemail.vue?vue&type=template&id=f8087764&scoped=true&"
import script from "./modal-viewemail.vue?vue&type=script&lang=js&"
export * from "./modal-viewemail.vue?vue&type=script&lang=js&"
import style0 from "./modal-viewemail.vue?vue&type=style&index=0&id=f8087764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8087764",
  null
  
)

export default component.exports